// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_ix","advertCardPhoto__image":"c-a_iy"};